import {
    FETCH_LOCATION_NOT_OFF_REQUEST,
    FETCH_LOCATION_NOT_OFF_SUCCESS,
    FETCH_LOCATION_NOT_OFF_FAILURE,
} from "../constants/LocationNotOffConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const LocationNotOffReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOCATION_NOT_OFF_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_LOCATION_NOT_OFF_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_LOCATION_NOT_OFF_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default LocationNotOffReducer;
